import FileManagementPage from '../pages/FileManagementPage'
import CsvEtiquetasPage from '../pages/CsvEtiquetasPage'

const routes = [
    {
        name: 'FileManagementPage',
        path: '/file-management',
        component: FileManagementPage,
        meta: {
            requiresAuth: true,
            permission: 'FILE_SHOW',
        },
    },
    {
        name: 'CsvEtiquetasPage',
        path: '/csv-etiquetas',
        component: CsvEtiquetasPage,
        meta: {
            requiresAuth: true,
            permission: 'FILE_SHOW',
        },
    },
]

export default routes;
